import React from 'react';
import { colors } from '@styleseat/brand';

type SymbolsTwitterCircleIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SymbolsTwitterCircleIcon = ({
  width = 24,
  height = 24,
  color = colors.blackInBlack,
}: SymbolsTwitterCircleIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5,0 C27.1649831,0 35,7.83501688 35,17.5 C35,27.1649831 27.1649831,35 17.5,35 C7.83501688,35 0,27.1649831 0,17.5 C0,7.83501688 7.83501688,0 17.5,0 Z M21.8903249,9.37890625 C19.6548729,9.37890625 17.8396186,11.3476562 17.8396186,13.7721354 C17.8396186,14.1184896 17.8732345,14.4557292 17.9488701,14.7747396 C14.5788842,14.5924479 11.5954802,12.8424479 9.59533898,10.1809896 C9.25077684,10.828125 9.04908192,11.5846354 9.04908192,12.3867187 C9.04908192,13.9088542 9.76341808,15.2578125 10.8559322,16.0416667 C10.1920198,16.0234375 9.57012712,15.8229167 9.02387006,15.4947917 L9.02387006,15.5494792 L9.02387006,15.5494792 C9.02387006,17.6822917 10.4189266,19.4505208 12.2762006,19.8606771 C11.9400424,19.9609375 11.5786723,20.015625 11.2088983,20.015625 C10.9483757,20.015625 10.6962571,19.9882812 10.4441384,19.9335937 C10.9567797,21.6835937 12.4526836,22.9505208 14.2259181,22.9869792 C12.8392655,24.1627604 11.0912429,24.8645833 9.19194915,24.8645833 C8.86419492,24.8645833 8.54484463,24.8463542 8.22549435,24.8007812 C9.99872881,26.0585937 12.1333333,26.7877604 14.419209,26.7877604 C21.8735169,26.7877604 25.949435,20.0885417 25.949435,14.2825521 C25.949435,14.0911458 25.949435,13.8997396 25.9410311,13.7174479 C26.7310028,13.0976562 27.4201271,12.3229167 27.9663842,11.4388021 C27.2436441,11.7851562 26.4620763,12.0221354 25.6384887,12.1315104 C26.4788842,11.5846354 27.1175847,10.7278646 27.4201271,9.69791667 C26.6385593,10.1992187 25.772952,10.5638021 24.8485169,10.7643229 C24.1089689,9.90755208 23.0584746,9.37890625 21.8903249,9.37890625 Z"
      fill={color}
    />
  </svg>
);
